import Vue from 'vue';

export const EventBus = new Vue();

export enum Event {
    ServiceCompleted = 'service-completed',
    ServiceMoved = 'service-moved',
    ServicePendingDelete = 'service-pending-delete',
    ServiceDeleted = 'service-deleted',
    BrakeCheckUpdated = 'brake-check-updated',
    CampaignUnitMoved = 'campaign-unit-moved',
    CampaignUpdated = 'campaign-updated',
    CampaignCompleted = 'campaign-completed',
    DefectCompleted = 'defect-completed',
    DefectPhotoDeleted = 'defect-photo-deleted',
    DefectRejected = 'defect-rejected',
    DefectScheduled = 'defect-scheduled',
    DefectMoved = 'defect-moved',
    DefectSchedulesUpdated = 'defect-schedules-updated',
    DefectSourcesUpdated = 'defect-sources-updated',
    DefectCategoriesUpdated = 'defect-categories-updated',
    DefectRatingsUpdated = 'defect-rating-updated',
    DateBasedTaskUpdated = 'date-based-task-updated',
    DateBasedTaskPendingDelete = 'date-based-task-pending-delete',
    DateBasedTaskDeleted = 'date-based-task-deleted',
    DateBasedTaskCompleted = 'date-based-task-completed',
    UnitMeterResetPendingAdd = 'unit-meter-reset-pending-add',
    UnitMeterResetPendingUpdate = 'unit-meter-reset-pending-update',
    UnitMeterResetPendingDelete = 'unit-meter-reset-pending-delete',
    ContainerPendingDelete = 'container-pending-delete',
    VehicleOffRoadPendingDelete = 'vehicle-off-road-pending-delete',
    VehicleOffRoadDeleted = 'vehicle-off-road-deleted',
    VehicleOffRoadPendingAdd = 'vehicle-off-road-pending-add',
    VehicleOffRoadPendingUpdate = 'vehicle-off-road-pending-update',
    VehicleOffRoadUpdated = 'vehicle-off-road-updated',
    ContainersUpdated = 'containers-updated',
    ContainerSizesUpdated = 'container-sizes-updated',
    UnitMeterResetUpdated = 'unit-meter-reset-updated',
    UnitMeterResetDeleted = 'unit-meter-reset-deleted',
    UnitUpdated = 'unit-updated',
    UserAuthenticated = 'user-authenticated',
    UserInfoReceived = 'user-info-received',
    GarageSelected = 'garage-selected',
    GarageLocationsUpdated = 'garage-locations-updated',
    GarageUnitSummaryUpdated = 'garage-unit-summary-updated',
    DocumentsUpdated = 'documents-updated',
    CustomWarrantyUpdated = 'custom-warranty-updated',
    CustomWarrantyDeleted = 'custom-warranty-deleted',
    OpenDefectNoticeClicked = 'open-defect-notice-clicked',
    AnnouncementUpdated = 'announcement-updated',
    AnnouncementDeleted = 'announcement-deleted',
    ChildLogVisibilityChanged = 'child-log-visibility-changed',
    ParentLogVisibilityChanged = 'parent-log-visibility-changed',
    CloseAllLogs = 'close-all-logs',
}

Vue.use({
    install(vue) {
        vue.prototype.$bus = EventBus;
    }
});
